import { TFunction } from '@frontend/i18n';
import { DateRangePeriod, QuickFillConfigOption } from '../../types/invoice';

export const quickRangeConfig = (
  t: TFunction,
  showAllTimeButton = false,
  showCurrentMonth = true
): QuickFillConfigOption[] => [
  {
    label: t('Today', { ns: 'payments' }),
    period: 'day',
    startShift: 0,
    endShift: 0,
  },
  {
    label: t('Yesterday', { ns: 'payments' }),
    period: 'day',
    startShift: 1,
    endShift: 0,
  },
  ...(showCurrentMonth
    ? [
        {
          label: t('Current Month', { ns: 'payments' }),
          period: 'month' as DateRangePeriod,
          startShift: 0,
          endShift: 0,
        },
      ]
    : []),
  {
    label: t('Last Month', { ns: 'payments' }),
    period: 'month',
    startShift: 1,
    endShift: 0,
  },
  ...(showAllTimeButton
    ? [
        {
          label: t('All Time', { ns: 'payments' }),
          period: 'all' as DateRangePeriod,
        },
      ]
    : []),
  {
    label: t('Custom', { ns: 'payments' }),
    period: 'custom',
  },
];
